import { render, staticRenderFns } from "./GamificationProgress.vue?vue&type=template&id=1ba987de&scoped=true&"
import script from "./GamificationProgress.vue?vue&type=script&lang=ts&"
export * from "./GamificationProgress.vue?vue&type=script&lang=ts&"
import style0 from "./GamificationProgress.vue?vue&type=style&index=0&id=1ba987de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba987de",
  null
  
)

export default component.exports